// extracted by mini-css-extract-plugin
module.exports = {"comment-signature":"_1Ev9w","commentSignature":"_1Ev9w"};